import styled from '@emotion/styled';

export const SadaEmployeeWorkload = styled.div``;
